// Vendor Libs
import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import uuid from 'uuid'; // DishTech React

import { actions } from '@dishtech-react/redux';
var _closeOverlay = actions.closeOverlay,
    _closeAllOverlays = actions.closeAllOverlays,
    _openOverlay = actions.openOverlay;
export var useOverlay = function useOverlay(_ref) {
  var id = _ref.id,
      title = _ref.title;
  var dispatch = useDispatch();

  var _useRef = useRef(id || title + "-" + uuid.v4()),
      overlayId = _useRef.current;

  return {
    closeAllOverlays: function closeAllOverlays() {
      return dispatch(_closeAllOverlays());
    },
    closeOverlay: function closeOverlay() {
      return dispatch(_closeOverlay(overlayId));
    },
    open: useSelector(function (_ref2) {
      var _ref2$overlay = _ref2.overlay;
      _ref2$overlay = _ref2$overlay === void 0 ? {} : _ref2$overlay;
      var _ref2$overlay$overlay = _ref2$overlay[overlayId],
          open = _ref2$overlay$overlay === void 0 ? false : _ref2$overlay$overlay;
      return open;
    }),
    openOverlay: function openOverlay() {
      return dispatch(_openOverlay(overlayId));
    },
    overlayId: overlayId
  };
};